import React, { useEffect, useRef, useState, useCallback } from "react";
import {
  Col,
  Row,
  Card,
  Button,
  Divider,
  Switch,
  Input,
  Badge,
  Checkbox,
  Select,
  Radio,
  ConfigProvider,
  Modal,
} from "antd";
import SignatureCanvas from "react-signature-canvas";

import Message from "../../Components/common/Message";
import "./vr.css";
import { useLocation, useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import {
  adBlueReading,
  EMAIL_ENDPOINTS,
  fuelReading,
  refrigeratorReading,
  vehicleDefects,
  washerReading,
} from "../../Components/common/Constants";
import AuthService from "../../Components/auth/AuthService";
import { useDispatch, useSelector } from "react-redux";
import { Autocomplete, TextField, Button as UploadBtn } from "@mui/material";

import {
  ArrowLeftOutlined,
  CheckOutlined,
  CloseOutlined,
  SignatureFilled,
  StarFilled,
  WarningOutlined,
} from "@ant-design/icons";
import ReportModal from "../../Components/Modals/ReportModal";
import config, { env } from "../../Components/config";
import qs from "query-string";
import { hideLoading, showLoading, useLoadingDispatch } from "../../context/loadingContext";

const Auth = new AuthService();
const useStyles = makeStyles((theme) => ({
  antInput: {
    "& .ant-input": {
      height: "40px",
    },
  },
  dataSheet: {
    "& .ant-checkbox .ant-checkbox-inner": {
      width: "36px",
      height: "36px"
    },
    "& .ant-checkbox+span": {
      fontSize: '16px',
      paddingTop: '6px'
    },
    "& .ant-checkbox-checked .ant-checkbox-inner:after": {
      width: '10px',
      height: '22px'
    },
    "& .ant-switch .ant-switch-inner": {
      transition: 'padding-inline-start 0.0s ease-in-out, padding-inline-end 0.0s ease-in-out;'
    }
  }
}));

const VehicleReport = () => {
  const { pinValidity, driverRoutes, selectedRoute } = useSelector((state) => state?.AppState?.driverData);
  const navigate = useNavigate();
  const { TextArea } = Input;
  const { Option } = Select;
  const classes = useStyles();
  const signatureCanvasRef = useRef(null);
  const dispatch = useDispatch();
  const securityPinExists = localStorage.getItem("securityPin");
  const driverID = localStorage.getItem("driver_id");
  const vehicleID = localStorage.getItem("accident_vehicle_id");
  var layoutDispatch = useLoadingDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [loadMessage, setLoadMessage] = React.useState("");
  const [type, setType] = React.useState("info");
  const [odoMeter, setOdoMeter] = useState("");
  const [fuel, setFuel] = useState(null);
  const [adBlue, setAdBlue] = useState(null);
  const [washer, setWasher] = useState("");
  const [refrigerator, setRefrigerator] = useState(null);
  const [notes, setNotes] = useState("");
  const [signature, setSignature] = useState("");
  const [allDefectsSheet, setAllDefectsSheet] = useState([...vehicleDefects]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDefectItem, setSelectedDefectItem] = useState({});
  const [files, setFiles] = React.useState([]);
  const [deletedFiles, setDeletedFiles] = React.useState([]);
  const [uploadedFilesTemp, setUploadedFilesTemp] = useState({});
  const [fuelCheck, setFuelCheck] = useState(false);
  const [tachType, setTachType] = useState(null);
  const [isFirstTime, setIsFirstTime] = useState(false);
  const [nonTachoAuthorized, setNonTachoAuthorized] = useState(0);
  const [defectSheetId, setDefectSheetId] = useState(null);
  const [savedTachoType, setSavedTachoType] = useState(null);
  const [height_feets, setHeight_feets] = useState("");
  const [height_inches, setHeight_inches] = useState("");
  const [height_meters, setHeight_meters] = useState("");
  const [height_centimeters, setHeight_centimeters] = useState("");

  const currentRoute = driverRoutes.find((item => item.id === selectedRoute))


  const location = useLocation();
  const readR = location?.state?.readReport;

  const clearSignature = () => {
    signatureCanvasRef.current.clear();
    setSignature('')
  };

  const saveSignature = () => {
    const signatureImage = signatureCanvasRef.current.toDataURL();
    setSignature(signatureImage);
    console.log("Signature Image:", signatureImage);
  };

  // useEffect(() => {
  //   const item = reportSubmit?.find(item => item.route_id === selectedRoute);
  //   if (item && item.status === true) {
  //     navigate('/dashboard');
  // }
  // }, []);


  const showModal = (item) => {
    setSelectedDefectItem(item);
    setIsModalOpen(true);
  };

  const handleDeleteFile = (fileName) => {
    const updatedFiles = files.filter((file) => file.name !== fileName);
    setFiles(updatedFiles);
  };
  console.log("fils", files);


  const sendEmailToNonTachoAuthorizers = async (emailPayload) => {
    try {
      const { url, token } = EMAIL_ENDPOINTS[env] || EMAIL_ENDPOINTS.default;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(emailPayload),
      });

      return await response.json();
    } catch (error) {
      console.error("Error sending email:", error);
    }
  };

  const handleSubmitReport = async () => {
    let rand = Math.random() * 50;
    let str = " ";
    for (let i = 0; i < rand; i++) {
      str += " ";
    }

    const requiredDefects = allDefectsSheet.filter(
      (defect) => defect.required && !defect.status
    );

    // if (requiredDefects.length > 0) {
    //   setType("error");
    //   setLoadMessage(`Please Check the required defects before submitting the report${str}`);
    //   return;
    // }

    if (!odoMeter) {
      setType("error");
      setLoadMessage("Please enter the odometer reading" + str);
      return;
    } else if (!fuel) {
      setType("error");
      setLoadMessage("Please select truck fuel level" + str);
      return;
    } else if (!adBlue) {
      setType("error");
      setLoadMessage("Please select ad blue level" + str);
      return;
    } else if (!refrigerator) {
      setType("error");
      setLoadMessage("Please select refrigerator fuel level" + str);
      return;
    } else if (tachType == null) {
      setType("error");
      setLoadMessage("Please select tacho" + str);
      return;
    }
    const imperialMatch = String(height_feets) === String(currentRoute?.height_feets ?? "") && String(height_inches) === String(currentRoute?.height_inches ?? "");
    const metricMatch = String(height_meters) === String(currentRoute?.height_meters ?? "") && String(height_centimeters) === String(currentRoute?.height_centimeters ?? "");
    const isImperialZero = (Number(height_feets) === 0 || height_feets === "") && (Number(height_inches) === 0 || height_inches === "");
    const isMetricZero = (Number(height_meters) === 0 || height_meters === "") && (Number(height_centimeters) === 0 || height_centimeters === "");

    if (!((imperialMatch && (isMetricZero || metricMatch)) || (metricMatch && (isImperialZero || imperialMatch)))) {
      setType("error");
      setLoadMessage("Height values do not match the vehicle's registered height." + str);
      return;
    }

    if (isFirstTime) {
      Modal.confirm({
        title: <span style={{ fontSize: '18px', fontWeight: 700 }}>Confirm Report Submission</span>,
        centered: true,
        content: (
          <div style={{ padding: '8px 0' }}>
            <div style={{
              background: tachType === 0 ? '#fff1f0' : '#e6f7ff',
              border: `1px solid ${tachType === 0 ? '#ffa39e' : '#91d5ff'}`,
              padding: '12px',
              borderRadius: '10px',
              marginBottom: '12px',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.02)'
            }}>
              <span style={{ fontSize: '15px', fontWeight: 500, color: '#262626' }}>
                Tacho Selection:
                <strong style={{ marginLeft: '8px', color: tachType === 0 ? '#cf1322' : '#096dd9', fontSize: '16px' }}>
                  {tachType === 0 ? "Manual Tacho" : "Tacho Uploaded"}
                </strong>
              </span>
            </div>

            <p style={{ color: '#595959', fontSize: '14px', lineHeight: '1.5', marginBottom: '12px' }}>
              Please note that this selection is <strong style={{ color: '#262626' }}>permanent</strong> for this route and <strong>cannot be changed</strong> once the report is submitted.
            </p>

            {tachType === 0 && (
              <div style={{
                padding: '12px',
                background: '#fffbe6',
                border: '1px solid #ffe58f',
                borderRadius: '10px',
                marginBottom: '12px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.02)'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#d59413ff', marginBottom: '4px' }}>
                  <WarningOutlined style={{ fontSize: '16px' }} />
                  <span style={{ fontWeight: 700, fontSize: '13px', letterSpacing: '0.5px', textTransform: 'uppercase' }}>Manual Tacho Note</span>
                </div>
                <p style={{ margin: 0, color: '#595959', fontSize: '13px', lineHeight: '1.4' }}>
                  You will be responsible for manually recording your <strong>Start Drive</strong> and <strong>Break</strong> activities throughout the route.
                </p>
              </div>
            )}

            <div style={{
              marginTop: '16px',
              paddingTop: '12px',
              borderTop: '1px solid #f0f0f0',
            }}>
              <p style={{ fontWeight: 600, fontSize: '15px', color: '#262626', margin: 0 }}>
                Are you sure you want to proceed?
              </p>
            </div>
          </div>
        ),
        onOk: () => {
          executeSubmission(str, requiredDefects);
        },
        okText: "Confirm & Submit",
        cancelText: "Cancel",
        width: 600,
        okButtonProps: {
          size: "large",
          danger: tachType === 0,
          style: { borderRadius: '10px', fontWeight: 600, height: '44px', minWidth: '160px' }
        },
        cancelButtonProps: {
          size: "large",
          style: { borderRadius: '10px', height: '44px', minWidth: '100px' }
        },
      });
      return;
    }

    executeSubmission(str, requiredDefects);
  }

  const executeSubmission = async (str = " ", requiredDefects = []) => {
    let isAuthorized = nonTachoAuthorized === 1;

    if (tachType === 0 && nonTachoAuthorized === 0 && !isFirstTime) {
      setIsLoading(true);
      try {
        const { check_defect_sheet } = await Auth.fetch(
          `/driverapp/vehicle-defect-sheet?route_status_id=${selectedRoute}&driver_id=${driverID}&vehicle_id=${vehicleID}`
        );
        setIsLoading(false);
        const latestAuthorizedValue = check_defect_sheet?.[0]?.non_tacho_authorized ?? 0;
        setNonTachoAuthorized(latestAuthorizedValue);
        isAuthorized = latestAuthorizedValue === 1;

        if (latestAuthorizedValue === 0) {
          setType("error");
          setLoadMessage("You are not authorized to use Manual Tacho. Please contact management." + str);
          return;
        }
      } catch (err) {
        setIsLoading(false);
        console.error("Error checking authorization:", err);
        setType("error");
        setLoadMessage("Error checking authorization. Please try again." + str);
        return;
      }
    }

    if (!signature) {
      setType("error");
      setLoadMessage("Please Sign the report" + str);
      return;
    }

    setIsLoading(true);
    const dataToSend = {
      route_status_id: selectedRoute,
      odo_meter: odoMeter,
      fuel: fuel,
      ad_blue: adBlue,
      refrigerator_fuel: refrigerator,
      // wiper_washer_liquid: washer,
      notes: notes,
      signature: signature,
      deleted_files: deletedFiles,
      driver_id: JSON.parse(driverID),
      vehicle_id: JSON.parse(vehicleID),
      tacho: tachType,
      fuel_card: fuelCheck ? 1 : 0,
      type: 1,
      height_feets,
      height_inches,
      height_meters,
      height_centimeters
    };

    allDefectsSheet.map((d) => {
      dataToSend[d.key] = d.status == true ? 1 : 0;
      dataToSend[d.key + "_images"] = d.images ? d.images : [];
      dataToSend[d.key + "_notes"] = d.notes;
      dataToSend[d.key + "_not_road_worthy"] =
        d.not_road_worthy == true ? 1 : 0;
    });

    try {

      const res = await Auth.fetch("/driverapp/vehicle-defect-sheet", {
        method: "POST",
        body: JSON.stringify(dataToSend),
      });
      if (res?.ack) {
        if (tachType === 0 && isFirstTime) {
          sendEmailToNonTachoAuthorizers({
            vehicle_defect_id: res?.record_id,
            driver: currentRoute?.driver_name,
            vehicle: currentRoute?.vehicle,
            route: currentRoute?.route,
            route_date: localStorage.getItem("delivery_date")
          })
          setLoadMessage("Email sent for Manual Tacho authorization." + str);
          setIsFirstTime(false);
        }

        const uploadPromises = files.map(async (f) => {
          try {
            const uploadUrl = await getUploadUrl(f);
            await uploadFileToS3(uploadUrl, f.file, f.file.type);
          } catch (error) {
            console.error("Error uploading file:", error);
          }
        });
        Promise.all(uploadPromises).then(() => {
          if (requiredDefects?.length > 0) {
            setType("error");
            setLoadMessage(`All required defect checks must be completed before initiating the route. Please report the defects to transport manager ${str}`);
            setIsLoading(false);
          } else if (tachType === 0 && !isAuthorized) {
            setType("success");
            setLoadMessage("Report submitted successfully. Your Manual Tacho request is pending authorization from management." + str);
            setIsLoading(false);
          } else {
            dispatch({ type: 'SUBMIT_REPORT', payload: { route_id: selectedRoute, status: true } })
            localStorage.setItem('tachoType', tachType)
            setSavedTachoType(tachType)
            navigate("/routes");
            setIsLoading(false);
          }
        });
      } else {
        setIsLoading(false);
        setType("error");
        setLoadMessage(res.message);
      }
    } catch (err) {
      console.log(err);
    }
  };
  console.log(allDefectsSheet);

  useEffect(() => {
    const initialUploadedFilesTemp = {};
    allDefectsSheet.forEach((defect) => {
      initialUploadedFilesTemp[defect.key] = [];
    });
    setUploadedFilesTemp(initialUploadedFilesTemp);
  }, []);

  const getDataByRouteID = async () => {
    dispatch({ type: "LOADING", payload: true });
    showLoading(layoutDispatch);
    try {
      const { check_defect_sheet } = await Auth.fetch(
        `/driverapp/vehicle-defect-sheet?route_status_id=${selectedRoute}&driver_id=${driverID}&vehicle_id=${vehicleID}&date=${localStorage.getItem("delivery_date")}`
      );

      setIsFirstTime(check_defect_sheet?.length ? false : true);

      if (check_defect_sheet?.length) {
        setDefectSheetId(check_defect_sheet?.at(0)?.id || null);
        setNonTachoAuthorized(check_defect_sheet[0]?.non_tacho_authorized ?? 0);
        let newDefectSheet = check_defect_sheet.find((item => item.type == 1));
        setAllDefectsSheet((prevDefects) => {
          return Object.entries(newDefectSheet).reduce(
            (updatedDefects, [key, value]) => {
              const defectIndex = updatedDefects.findIndex(
                (defect) =>
                  defect.key ===
                  key.replace(/(_notes|_images|_not_road_worthy)$/, "")
              );
              if (defectIndex !== -1) {
                const updatedDefect = { ...updatedDefects[defectIndex] };
                if (key.endsWith("_notes")) {
                  updatedDefect.notes = value;
                } else if (key.endsWith("_images")) {
                  updatedDefect.images = JSON.parse(value);
                } else if (key.endsWith("_not_road_worthy")) {
                  updatedDefect.not_road_worthy = value === 1 ? true : false;
                } else {
                  updatedDefect.status = value === 1;
                }
                updatedDefects[defectIndex] = updatedDefect;
              }
              return updatedDefects;
            },
            [...prevDefects]
          );
        });
        setNotes(newDefectSheet?.notes);
        setTachType(newDefectSheet?.tacho ?? 1);
        setSavedTachoType(newDefectSheet?.tacho ?? 1);
        setFuelCheck(newDefectSheet?.fuel_card == 1 ? true : false);
        setSignature(newDefectSheet?.signature);
        setOdoMeter(newDefectSheet?.odo_meter);
        const readingFuel = fuelReading.find(
          (obj) => obj.id == newDefectSheet?.fuel
        );
        setFuel(newDefectSheet?.fuel);
        const readingAdBlue = fuelReading.find(
          (obj) => obj.id == newDefectSheet?.ad_blue
        );
        setAdBlue(newDefectSheet?.ad_blue);
        const readingRefrigerator = refrigeratorReading.find(
          (obj) => obj.id == newDefectSheet?.refrigerator_fuel
        );
        setRefrigerator(newDefectSheet?.refrigerator_fuel);
        const readingWiper = washerReading.find(
          (obj) => obj.id == newDefectSheet?.wiper_washer_liquid
        );
        setWasher(newDefectSheet?.wiper_washer_liquid);
        setHeight_feets(newDefectSheet?.height_feets ?? "");
        setHeight_inches(newDefectSheet?.height_inches ?? "");
        setHeight_meters(newDefectSheet?.height_meters ?? "");
        setHeight_centimeters(newDefectSheet?.height_centimeters ?? "");
      } else {
        setAllDefectsSheet([...vehicleDefects]);
      }
    } catch (err) {
      console.log(err);
    } finally {
      dispatch({ type: "LOADING", payload: false });
      hideLoading(layoutDispatch);

    }
  };

  const checkTachoAuthorization = async () => {
    try {
      const { check_defect_sheet } = await Auth.fetch(
        `/driverapp/vehicle-defect-sheet?route_status_id=${selectedRoute}&driver_id=${driverID}&vehicle_id=${vehicleID}`
      );
      if (check_defect_sheet?.length) {
        const latestAuthorizedValue = check_defect_sheet[0]?.non_tacho_authorized ?? 0;
        if (latestAuthorizedValue !== nonTachoAuthorized) {
          setNonTachoAuthorized(latestAuthorizedValue);
        }
      }
    } catch (err) {
      console.error("Error checking tacho authorization:", err);
    }
  };

  useEffect(() => {
    let intervalId;
    if (tachType === 0 && nonTachoAuthorized === 0 && !isFirstTime) {
      intervalId = setInterval(checkTachoAuthorization, 15000);
    }
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [tachType, nonTachoAuthorized, isFirstTime, selectedRoute, driverID, vehicleID]);

  useEffect(() => {
    getDataByRouteID();
  }, []);

  if (!pinValidity) {
    localStorage.removeItem("DriverName");
    localStorage.removeItem("securityPin");
    localStorage.removeItem("driverRoutes");
    localStorage.removeItem("route_name");
    localStorage.removeItem("driver_id");
    localStorage.removeItem("manualTachos");
    navigate("/pin");
    localStorage.setItem('routeLocation', false)
    dispatch({ type: "RESET_STATE" });
  }

  if (!securityPinExists) {
    navigate("/pin");
    localStorage.removeItem("DriverName");
    localStorage.removeItem("driverRoutes");
    localStorage.removeItem("route_name");
    localStorage.removeItem("driver_id");
    localStorage.removeItem("manualTachos");
    localStorage.setItem('routeLocation', false)
    dispatch({ type: "RESET_STATE" });
  }

  const handleSwitchToggle = (itemID, isChecked) => {
    setAllDefectsSheet((prevDefects) => {
      const updatedDefects = prevDefects.map((defect) =>
        defect.id === itemID ? { ...defect, status: isChecked } : defect
      );
      return updatedDefects;
    });
  };

  const handleHeightChange = (key, value) => {
    if (parseFloat(value) < 0 && value !== "") return;
    if (key === 'height_feets') setHeight_feets(value);
    if (key === 'height_inches') setHeight_inches(value);
    if (key === 'height_meters') setHeight_meters(value);
    if (key === 'height_centimeters') setHeight_centimeters(value);
  };
  console.log("filess", files);

  const getUploadUrl = async (file) => {
    const params = {
      bucket: config.tms_uploads_bucket,
      ContentType: file.file.type,
      Key: config.env + "/defect_sheets/" + selectedRoute + "/" + file.name,
    };
    const response = await fetch(
      `${config.domain}/generate-put-url?${qs.stringify(params)}`,
      {
        headers: {
          "Content-Type": params.ContentType,
        },
      }
    );
    return response.json();
  };

  const uploadFileToS3 = async (uploadUrl, file, contentType) => {
    const response = await fetch(uploadUrl.putURL, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": contentType,
      },
    });
    if (response.status !== 200) {
      throw new Error("File upload failed.");
    }
  };

  const handleKeyPress = useCallback((event) => {
    if (event.ctrlKey) {
      if (event.key == "b") {
        console.log(`Key pressed: ${event.key}`);

        setAllDefectsSheet((prevDefects) => {
          const updatedDefects = prevDefects.map((defect) =>
            defect.required === true ? { ...defect, status: !defect.status } : defect
          );
          return updatedDefects;
        });

      }
    }
  }, []);

  useEffect(() => {
    // attach the event listener
    document.addEventListener("keydown", handleKeyPress);

    // remove the event listener
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [handleKeyPress]);

  const specialKeys = ['pumptruck', 'atlas'];

  return (
    <div className={classes.dataSheet}>
      <Row style={{ display: "flex", justifyContent: 'space-between' }}>
        <Button size="large" icon={<ArrowLeftOutlined />} onClick={() => navigate("/dashboard")}>Back</Button>
      </Row>
      <h2 className="report-box-heading">Vehicle Defect Report</h2>
      <>
        <Row gutter={[16, 16]}>
          {allDefectsSheet?.filter(item => !specialKeys.includes(item.key)).map((item, index) => {
            return (
              <Col key={item.id} xs={24} sm={16} md={12} lg={8} xl={6}>
                <Card
                  size="small"
                  style={{
                    minWidth: 250,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Switch
                        style={{
                          backgroundColor: item.status ? "green" : "#FF2E2E",
                          marginRight: "10px",
                        }}
                        checkedChildren={<CheckOutlined />}
                        unCheckedChildren={<CloseOutlined />}
                        checked={item.status}
                        onChange={(checked) => handleSwitchToggle(item.id, checked)}
                      />
                      <span
                        style={{
                          fontSize: "12px",
                          marginRight: "5px",
                          fontWeight: "bold",
                        }}
                      >
                        {item.title}
                        <span style={{ color: "red", fontSize: "15px" }}>
                          {item.required && "*"}
                        </span>
                      </span>
                    </div>
                    <div>
                      {item.not_road_worthy && (
                        <WarningOutlined
                          style={{
                            fontSize: "20px",
                            color: "red",
                            marginRight: "5px",
                          }}
                        />
                      )}
                      <UploadBtn
                        component="label"
                        sx={{ padding: "0", minWidth: "30px", marginRight: "15px" }}
                        onClick={() => showModal(item)}
                      >
                        <Badge
                          color="#1890ff"
                          dot={item.images?.length > 0 || item?.notes}
                        >
                          <SignatureFilled
                            style={{ fontSize: "25px", color: "grey" }}
                          />
                        </Badge>
                      </UploadBtn>
                    </div>
                  </div>
                </Card>
              </Col>
            );
          })}
        </Row>
        <Divider />
        <Row gutter={[16, 16]}>
          {allDefectsSheet?.filter(item => item.key === 'pumptruck' || item.key === 'atlas').map((item, index) => {
            return (
              <Col key={item.id} xs={24} sm={16} md={12} lg={8} xl={6}>
                <Card
                  size="small"
                  style={{
                    minWidth: 250,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Switch
                        style={{
                          backgroundColor: item.status ? "green" : "#FF2E2E",
                          marginRight: "10px",
                        }}
                        checkedChildren={<CheckOutlined />}
                        unCheckedChildren={<CloseOutlined />}
                        checked={item.status}
                        onChange={(checked) => handleSwitchToggle(item.id, checked)}
                      />
                      <span
                        style={{
                          fontSize: "12px",
                          marginRight: "5px",
                          fontWeight: "bold",
                        }}
                      >
                        {item.title}
                        <span style={{ color: "red", fontSize: "15px" }}>
                          {item.required && "*"}
                        </span>
                      </span>
                    </div>
                    <div>
                      {item.not_road_worthy && (
                        <WarningOutlined
                          style={{
                            fontSize: "20px",
                            color: "red",
                            marginRight: "5px",
                          }}
                        />
                      )}
                      <UploadBtn
                        component="label"
                        sx={{ padding: "0", minWidth: "30px", marginRight: "15px" }}
                        onClick={() => showModal(item)}
                      >
                        <Badge
                          color="#1890ff"
                          dot={item.images?.length > 0 || item?.notes}
                        >
                          <SignatureFilled
                            style={{ fontSize: "25px", color: "grey" }}
                          />
                        </Badge>
                      </UploadBtn>
                    </div>
                  </div>
                </Card>
              </Col>
            );
          })}
        </Row>
        <Row gutter={[16, 16]} style={{ marginTop: '10px' }}>
          <Col xs={24} sm={16} md={12} lg={10} xl={10}>
            <h5 style={{ margin: "1px 0px", fontWeight: "bold" }}>Height<span style={{ color: "red", fontSize: "10px" }}>*</span></h5>
            <Row gutter={[8, 8]}>
              <Col xs={24} sm={12}>
                <Input
                  size="large"
                  addonAfter={<div style={{ width: '80px', textAlign: 'center', fontSize: '12px', fontWeight: 'bold' }}>FEET</div>}
                  placeholder="Feet"
                  value={height_feets}
                  onChange={(e) => handleHeightChange('height_feets', e.target.value)}
                  type="number"
                  min={0}
                />
              </Col>
              <Col xs={24} sm={12}>
                <Input
                  size="large"
                  addonAfter={<div style={{ width: '80px', textAlign: 'center', fontSize: '12px', fontWeight: 'bold' }}>INCHES</div>}
                  placeholder="Inches"
                  value={height_inches}
                  onChange={(e) => handleHeightChange('height_inches', e.target.value)}
                  type="number"
                  min={0}
                />
              </Col>
              <Col span={24} style={{ color: '#888', fontStyle: 'italic', margin: '2px 0', fontWeight: 'bold' }}>
                OR
              </Col>
              <Col xs={24} sm={12}>
                <Input
                  size="large"
                  addonAfter={<div style={{ width: '80px', textAlign: 'center', fontSize: '12px', fontWeight: 'bold' }}>METERS</div>}
                  placeholder="Meters"
                  value={height_meters}
                  onChange={(e) => handleHeightChange('height_meters', e.target.value)}
                  type="number"
                  min={0}
                />
              </Col>
              <Col xs={24} sm={12}>
                <Input
                  size="large"
                  addonAfter={<div style={{ width: '80px', textAlign: 'center', fontSize: '12px', fontWeight: 'bold' }}>CENTIMETERS</div>}
                  placeholder="Centi Meter"
                  value={height_centimeters}
                  onChange={(e) => handleHeightChange('height_centimeters', e.target.value)}
                  type="number"
                  min={0}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </>
      <Divider />
      <Row gutter={[16, 4]}>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            Odometer<span style={{ color: "red", fontSize: "20px" }}>*</span>
          </h4>
          <div className={classes.antInput}>
            <Input
              placeholder="Enter odometer reading"
              onChange={(e) => setOdoMeter(e.target.value)}
              value={odoMeter}
              type="number"
            />
          </div>
        </Col>

        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            Truck Fuel Level
            <span style={{ color: "red", fontSize: "20px" }}>*</span>
          </h4>
          <Select
            style={{
              width: "100%",
            }}
            size="large"
            value={fuel}
            placeholder="Select Fuel Level"
            onChange={(value) => {
              setFuel(value);
            }}
          >
            {fuelReading.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.title}
              </Option>
            ))}
          </Select>
        </Col>

        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            AdBlue Level
            <span style={{ color: "red", fontSize: "20px" }}>*</span>
          </h4>
          {/* <Autocomplete
            id="adblue"
            size="small"
            options={adBlueReading}
            getOptionLabel={(option) => (option.title ? option.title : "")}
            value={adBlue}
            onChange={(e, values) => {
              setAdBlue(values);
            }}
            renderInput={(params) => (
              <TextField {...params} placeholder="Select adblue fuel level" />
            )}
          /> */}
          <Select
            style={{
              width: "100%",
            }}
            size="large"
            value={adBlue}
            placeholder="Select Ad Blue Level"
            onChange={(value) => {
              setAdBlue(value);
            }}
          >
            {adBlueReading.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.title}
              </Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            Refrigerator Fuel level
            <span style={{ color: "red", fontSize: "20px" }}>*</span>
          </h4>
          <Select
            style={{
              width: "100%",
            }}
            size="large"
            value={refrigerator}
            placeholder="Select Refrigerator Fuel level"
            onChange={(value) => {
              setRefrigerator(value);
            }}
          >
            {refrigeratorReading.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.title}
              </Option>
            ))}
          </Select>
        </Col>
        {/* <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            Wiper Washer Liquid Level
            <span style={{ color: "red", fontSize: "20px" }}>*</span>
          </h4>
          <Select
            style={{
              width: "100%",
            }}
            size="large"
            value={washer}
            placeholder="Select Wiper Washer Liquid Level"
            onChange={(value) => {
              setWasher(value);
            }}
          >
            {washerReading.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.title}
              </Option>
            ))}
          </Select>
        </Col> */}
      </Row>

      <Row gutter={16} style={{ marginTop: "15px" }}>
        <Col xs={24} sm={12} md={12} lg={12} xl={12}>
          <Checkbox
            checked={fuelCheck}
            onChange={(e) => {
              setFuelCheck(e.target.checked);
            }}
            size={36}
          >
            Fuel Card Collected
          </Checkbox>
        </Col>
      </Row>
      <Row gutter={16} style={{ marginTop: "15px" }}>
        <Col xs={24} sm={12} md={12} lg={12} xl={12}>
          <ConfigProvider
            theme={{
              components: {
                Radio: {
                  radioSize: 36,
                  dotSize: 12
                }
              }
            }}
          >
            <Radio.Group
              disabled={!isFirstTime && (savedTachoType === 1 || (savedTachoType === 0 && nonTachoAuthorized === 1))}
              className="custom-radio-group"
              defaultValue={tachType ?? 1}
              value={tachType}
              onChange={(v) => setTachType(v.target.value)}
              size="large"
              options={[
                { value: 1, label: 'Tacho Uploaded' },
                {
                  value: 0,
                  label: (
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                      Manual Tacho
                      {!isFirstTime && (tachType === 0 || nonTachoAuthorized === 1) && (
                        <div className={`tacho-status-badge ${nonTachoAuthorized === 1 ? 'authorized' : 'pending'}`}>
                          <span className="status-dot"></span>
                          {nonTachoAuthorized === 1 ? "Authorized" : "Authorization Pending"}
                        </div>
                      )}
                    </span>
                  )
                },
              ]}
            />
          </ConfigProvider>
        </Col>
      </Row>

      <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>Notes</h4>
      <div style={{ marginBottom: "10px" }}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <TextArea
              autoSize={{ minRows: 6, maxRows: 12 }}
              label="Notes"
              placeholder="Enter Any Specific Notes"
              onChange={(e) => setNotes(e.target.value)}
              value={notes}
            />
          </Col>
        </Row>
      </div>
      {/* <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
        Signature<span style={{ color: "red", fontSize: "20px" }}>*</span>
      </h4> */}
      <div
        style={{
          width: 390,
          display: "flex",
          alignItems: 'end',
          justifyContent: "space-between",
          marginTop: "15px",
        }}
      >
        <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
          Signature<span style={{ color: "red", fontSize: "15px" }}>*</span>
        </h4>
        <Button
          size="large"
          danger
          onClick={clearSignature}
        >
          Clear Signature
        </Button>
      </div>
      <div className="sign-con">
        <SignatureCanvas
          ref={signatureCanvasRef}
          value={signature}
          penColor="purple"
          canvasProps={{
            width: 390,
            height: 200,
            className: "signature-canvas",
          }}
          onEnd={saveSignature}
        />
        <div>
          {signature && <img height={150} width={250} src={signature} />}
        </div>
      </div>
      <div
        style={{
          width: 390,
          display: "flex",
          justifyContent: "space-between",
          marginTop: "15px",
        }}
      >
        {/* <Button size="large" onClick={clearSignature}>Clear Signature</Button> */}
        {/* <Button size="large" type="primary" onClick={saveSignature}>
          Save Signature
        </Button> */}
      </div>
      <Divider />
      <div className="box-button" style={{ marginTop: "15px" }}>
        <Button
          style={{
            height: "40px",
            width: "150px",
            padding: "4px",
            fontSize: "15px",
          }}
          size="large"
          type="primary"
          loading={isLoading}
          disabled={readR}
          onClick={handleSubmitReport}
        >
          Submit Report
        </Button>
      </div>
      {/* </div> */}

      <Message type={type} msg={loadMessage} />
      <ReportModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        selectedDefectItem={selectedDefectItem}
        setAllDefectsSheet={setAllDefectsSheet}
        allDefectsSheet={allDefectsSheet}
        setFiles={setFiles}
        files={files}
        setDeletedFiles={setDeletedFiles}
        deletedFiles={deletedFiles}
        uploadedFilesTemp={uploadedFilesTemp}
        setUploadedFilesTemp={setUploadedFilesTemp}
      />
    </div>
  );
};

export default VehicleReport;
